import React, { useState } from "react";
import EducationHistory from "./EducationHistory";
import { Icon } from "@iconify-icon/react";

import AddEditEducationHistory from "./AddEditEducationHistory";

interface ViewEducationHistoryProps {
  user: any;
}

const ViewEducationHistory = (props: ViewEducationHistoryProps) => {
  const [activeTab, setActiveTab] = useState(0);
  const [addEduOpen, setAddEduOpen] = useState(false);

  const tabs = [{ id: 0, label: "Education History" }];

  const modernStyles = {
    borderRadius: "6px",
    fieldHeight: "35px",
    focusShadow: "0 0 0 2px rgba(0, 120, 212, 0.2)",
    hoverBorderColor: "hsl(var(--primary))",
    activeBorderColor: "hsl(var(--primary))",
    labelColor: "hsl(var(--foreground))",
    placeholderColor: "hsl(var(--foreground))",
    spacing: "16px",
    descriptionColor: "hsl(var(--foreground))",
    backgroundColor: " hsl(var(--primary)))",
    hoveredBackgroundColor: "hsl(var(--primary))",
  };

  const tabContent = [
    <div key={0} className="content">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <h2
          className="contentTitle"
          style={{ display: "flex", alignItems: "center" }}
        >
          <Icon className="cardIcon" icon="tdesign:education-filled" />
          Education History
        </h2>
        <button
          type="button"
          onClick={() => setAddEduOpen(true)}
          className="btn-primary"
          style={{
            minWidth: "80px",
            borderRadius: modernStyles.borderRadius,
            backgroundImage: modernStyles.backgroundColor,
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 6,
          }}
        >
          <Icon icon="mdi:plus" />
          <span>Add Education</span>
        </button>
      </div>
      <div className="contentCard">
        <EducationHistory user={props.user} />
      </div>
    </div>,
  ];

  return (
    <div>
      <h1 className="title">Education History</h1>

      <div className="tabContainer">
        <nav className="tabNav">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`tabButton ${
                activeTab === tab.id ? "activeTab" : "inactiveTab"
              }`}
            >
              {tab.label}
            </button>
          ))}
        </nav>
      </div>

      <div className="contentContainer">{tabContent[activeTab]}</div>
      <AddEditEducationHistory
        isOpen={addEduOpen}
        onDismiss={() => setAddEduOpen(false)}
      />
    </div>
  );
};

export default ViewEducationHistory;
